import React, { FunctionComponent } from "react";
import WizardContainer, { WizardProps } from "../../containers/Wizard";
import { WIDGET_SELECTION_PATH, START_DATE_SELECTION_PATH } from "../../routing/paths";
import FillOrigamiSchedulingStep from "../FillOrigamiSchedulingStep";

const DURATION_SPELL_NAME = "duration";
const durations = [1, 2, 3, 4];

const FillOrigamiSchedulingStepProps = {
  previous: WIDGET_SELECTION_PATH,
  next: START_DATE_SELECTION_PATH,
  question: "How long do you want to run your ad",
  description: "The price will be calculated based on the duration.",
  spellName: DURATION_SPELL_NAME,
  required: true,
  showExpanded: false,
  options: durations,
};

export const DurationSelectionStep: FunctionComponent<WizardProps> = (
  props: WizardProps,
) => {
  return <FillOrigamiSchedulingStep {...props} {...FillOrigamiSchedulingStepProps} />;
};

export default WizardContainer(DurationSelectionStep);
